import type { Timestamp } from '@framework/Timestamp';

export const buildDateTimeArgs = (timestamp: Timestamp) => {
  const d = timestamp.toDate();
  const pad = (n: number): string => String(n).padStart(2, '0');
  return {
    now: d,
    year: d.getFullYear(),
    month: pad(d.getMonth() + 1),
    day: pad(d.getDate()),
    hour: pad(d.getHours()),
    minute: pad(d.getMinutes()),
  };
};
